import colors from '../../../../theme/foundations/colors'
import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'

export const addressHeadingStyle = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(18), pxToRem(18), pxToRem(22), pxToRem(22)],
    fontWeight: '600',
    lineHeight: 'normal',
    letterSpacing: pxToRem(3),
    textTransform: 'uppercase',
    marginBottom: '0px',
    paddingLeft: [pxToRem(11), pxToRem(11), pxToRem(11), '0px'],
    marginTop: [pxToRem(15), pxToRem(15), pxToRem(15), '0px']
}
export const modalContentStyle = {
    maxWidth: '733px',
    borderRadius: '0px',
    paddingLeft: [pxToRem(15), pxToRem(15), pxToRem(30), pxToRem(30)],
    paddingRight: [pxToRem(15), pxToRem(15), pxToRem(30), pxToRem(30)],
    paddingBottom: [pxToRem(30), pxToRem(30), pxToRem(40), pxToRem(40)],
    paddingTop: [pxToRem(30), pxToRem(30), pxToRem(40), pxToRem(40)],
    marginRight: [pxToRem(11), pxToRem(11), '0px', '0px'],
    marginLeft: [pxToRem(11), pxToRem(11), '0px', '0px'],
    marginTop: [pxToRem(168), pxToRem(168), pxToRem(144), pxToRem(144)]
}
export const addAddressCardStyle = {
    border: `${pxToRem(1)} dashed ${colors.cav_light_input_gray}`,
    background: 'white',
    color: 'cav_red',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: [pxToRem(1.5), pxToRem(1.5), pxToRem(1.68), pxToRem(1.68)],
    textTransform: 'uppercase',
    '&:hover': {
        background: 'white'
    }
}
export const editAddressHeadingStyle = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(18), pxToRem(18), pxToRem(22), pxToRem(22)],
    fontWeight: '600',
    lineHeight: 'normal',
    letterSpacing: pxToRem(3),
    textTransform: 'uppercase',
    marginBottom: '0px'
}
